const codes = [
    { code: "4Z", name: "Airlink" },
    { code: "AH", name: "Air Algérie" },
    { code: "UU", name: "Air Austral" },
    { code: "BP", name: "Air Botswana" },
    { code: "AC", name: "Air Canada" },
    { code: "HF", name: "Air Côte d'Ivoire" },
    { code: "AFC", name: "Air Fast Congo" },
    { code: "AF", name: "Air France" },
    { code: "MD", name: "Air Madagascar" },
    { code: "MK", name: "Air Mauritius" },
    { code: "NZ", name: "Air New Zealand" },
    { code: "HM", name: "Air Seychelles" },
    { code: "KP", name: "Asky Airlines" },
    { code: "BA", name: "BA" },
    { code: "GP", name: "APG" },
    { code: "PG", name: "Bangkok Airways" },
    { code: "CX", name: "Cathay Pacific" },
    { code: "5Z", name: "Cemair" },
    { code: "DE", name: "Condor" },
    { code: "DL", name: "Delta Air Lines" },
    { code: "MS", name: "EgyptAir" },
    { code: "LY", name: "El Al Israel Airlines" },
    { code: "EK", name: "Emirates Airlines" },
    { code: "ET", name: "Ethiopian Airlines" },
    { code: "EY", name: "Etihad Airways" },
    { code: "FN", name: "Fastjet" },
    { code: "AY", name: "Finnair" },
    { code: "X1", name: "Fly Namibia" },
    { code: "FA", name: "FlySafair" },
    { code: "KQ", name: "Kenya Airways" },
    { code: "KL", name: "KLM" },
    { code: "LA", name: "LATAM Airlines" },
    { code: "GE", name: "LIFT" },
    { code: "LH", name: "Lufthansa" },
    { code: "3W/ET", name: "Malawian Airlines" },
    { code: "PR", name: "Phillipines" },
    { code: "PW", name: "Precisionair" },
    { code: "P0", name: "Proflight Zambia" },
    { code: "QR", name: "Qatar Airways" },
    { code: "WB", name: "Rwandair" },
    { code: "RN", name: "Royal Eswatini Air" },
    { code: "SV", name: "Saudi Arabian Airlines" },
    { code: "SQ", name: "Singapore Airlines" },
    { code: "SA", name: "South African Airways" },
    { code: "LX", name: "Swiss" },
    { code: "DT", name: "TAAG" },
    { code: "TP", name: "TAP Portugal" },
    { code: "TK", name: "Turkish Airlines" },
    { code: "UA", name: "United Airlines" },
    { code: "VS", name: "Virgin Atlantic" },
    { code: "ZN", name: "Zambia Airways" }
];

export default codes;